<template lang="pug">
    v-autocomplete.account-selector(v-model="select" solo dense :hide-details="hideDetails" outlined  clearable item-text="name" item-value="key" :items="categories"  :placeholder="$t('Placeholder.__AccountType')" @click:clear="clearAction")
        template(v-slot:selection="data")
            | {{$t('AccountCategories.__' + data.item.key)}}

        template(v-slot:item="data")
            template(v-if="typeof data.item !== 'object'")
                v-list-item-content(v-text="data.item")
            template(v-else)
                v-list-item-content {{$t('AccountCategories.__' + data.item.key)}}
</template>
<script>
export default {
  props: {
    value: {
      type: String
    },
    groupKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    insertTag: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: null,
      items: [],
      select: [],
      categories: [],
      categoriesRaw: [
        {
          key: "Assets",
          categories: [
            {
              key: "CashAndCashEquivalents"
            },
            {
              key: "LongTermInvestments"
            },
            {
              key: "ShortTermInvestments"
            },
            {
              key: "AccountsReceivable"
            },
            {
              key: "Inventories"
            },
            {
              key: "PrepaidExpenses"
            },
            {
              key: "FixedAssets"
            },
            {
              key: "OtherAssets"
            }
          ]
        },
        {
          key: "Liabilities",
          categories: [
            {
              key: "CurrentLiabilities"
            },
            {
              key: "AccountsPayable"
            },
            {
              key: "LongTermLiabilities"
            },
            {
              key: "OtherLiabilities"
            }
          ]
        },
        {
          key: "OwnersEquity",
          categories: [
            {
              key: "Capital"
            },
            {
              key: "AdditionalPaidInCapital"
            },
            {
              key: "RetainedEarnings"
            }
          ]
        },
        {
          key: "Income",
          categories: [
            {
              key: "SalesRevenue"
            },
            {
              key: "ServiceRevenue"
            },
            {
              key: "OtherOperatingRevenue"
            }
          ]
        },
        {
          key: "OperatingCosts",
          categories: [
            {
              key: "CostOfGoodsSold"
            },
            {
              key: "Purchases"
            },
            {
              key: "ServiceCosts"
            },
            {
              key: "OtherOperatingCosts"
            }
          ]
        },
        {
          key: "OperatingExpenses",
          categories: [
            {
              key: "Expenses"
            },
            {
              key: "OtherOperatingExpenses"
            }
          ]
        }
      ],
      groupSortPriority: {
        Assets: 1,
        Liabilities: 2,
        Income: 3,
        OperatingExpenses: 4,
        OperatingCosts: 5,
        OwnersEquity: 6
      }
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    },
    groupKeys() {
      this.handleRawCategoriesData(this.categoriesRaw)
    }
  },
  methods: {
    clearAction() {
      this.$emit("input", null)
    },
    getCategories() {
      this.$store
        .dispatch("accounting/getCategories")
        .then(
          function(response) {
            this.categoriesRaw = response.data.groups
            this.handleRawCategoriesData(this.categoriesRaw)
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    handleRawCategoriesData(rawData) {
      // sorting
      rawData.sort(
        function(a, b) {
          return this.groupSortPriority[a.key] - this.groupSortPriority[b.key]
        }.bind(this)
      )
      var categories = []
      var groupKeys = this.groupKeys
      rawData.map(group => {
        if (groupKeys.length == 0 || groupKeys.includes(group.key)) {
          var groupCategories = []
          groupCategories.push({
            header: this.$t("AccountGroups.__" + group.key)
          })
          group.categories.map(category => {
            groupCategories.push(category)
          })
          groupCategories.push({ divider: true })
          categories = categories.concat(groupCategories)
        }
      })
      this.categories = categories
    }
  },
  mounted() {
    this.getCategories()
    // this.handleRawCategoriesData(this.categoriesRaw)
    this.select = this.value
  }
}
</script>
